"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _ArrowDownLine = _interopRequireDefault(require("@rsuite/icon-font/lib/direction/ArrowDownLine"));

// Generated by script, don't edit it please.
var ArrowDownLine = (0, _createSvgIcon["default"])({
  as: _ArrowDownLine["default"],
  ariaLabel: 'arrow down line',
  category: 'direction',
  displayName: 'ArrowDownLine'
});
var _default = ArrowDownLine;
exports["default"] = _default;
module.exports = exports.default;